import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import { Typography } from '../../../components/Wrappers/Wrappers.jsx';
import { useStyles } from './featuredPlacementSection.styles';

function FeaturedPlacementSection ({ onRequestFeatured }) {
    const classes = useStyles();

    return (
        <div className={classes.banner}>
            <div className={classes.copy}>
                <Typography variant={'h5'} weight={'bold'} className={classes.heading}>
                    Request featured placement
                </Typography>
                <Typography variant={'body1'} className={classes.description}>
                    Planning an upcoming launch, major event, or priority campaign? Talk to the ECAL
                    Support agent about spotlight placement on the ECAL World home page. Tell us more
                    about your campaign and preferred dates.
                </Typography>
            </div>

            <div className={classes.ctaWrapper}>
                <Button
                    variant={'contained'}
                    className={classes.ctaButton}
                    onClick={onRequestFeatured}
                >
                    REQUEST TO BE FEATURED
                    <ArrowForwardIcon fontSize={'small'} style={{ marginLeft: 8 }} />
                </Button>
            </div>
        </div>
    );
}

FeaturedPlacementSection.propTypes = {
    onRequestFeatured: PropTypes.func,
};

FeaturedPlacementSection.defaultProps = {
    onRequestFeatured: () => {},
};

export default FeaturedPlacementSection;
